<template>
  <SkeletonItem
    v-if="loading"
    :height="`${iconSize}px`"
    :width="`${iconSize}px`"
    :border-radius="resolvedBorderRadius"
  />
  <div
    v-else
    :class="{ 'gi-GroupIcon-clickable': clickable }"
    :style="{
      '--size': `${iconSize}px`,
      '--color': color
    }"
    class="gi-GroupIcon"
    @click="onClick"
  >
    <AppIcon :height="iconSize" :icon-name="resolvedIconName" :width="iconSize" />
  </div>
</template>

<script setup>
import { isNull } from 'lodash'
import { computed } from 'vue'

import { GLOBAL_GROUPS_ICON_PREFIX, GROUPS_CATEGORIZED_COLORS } from '@/utils/global-groups'

import AppIcon from '@/components/ui/AppIcon/AppIcon'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'GroupIcon'
})

const props = defineProps({
  iconName: {
    type: [String, Number],
    default: '1'
  },

  color: {
    type: String,
    default: GROUPS_CATEGORIZED_COLORS.BLACK[0]
  },

  loading: {
    type: Boolean
  },

  clickable: {
    type: Boolean
  },

  iconSize: {
    type: Number,
    default: 24
  },

  borderRadius: {
    type: Number,
    default: null
  }
})

const resolvedBorderRadius = computed(() => {
  if (isNull(props.borderRadius)) {
    return `${props.iconSize / 4}px`
  }

  return `${props.borderRadius}px`
})

const resolvedIconName = computed(() => `${GLOBAL_GROUPS_ICON_PREFIX}${props.iconName}`)

const emit = defineEmits({
  click: null
})

const onClick = () => {
  if (props.clickable) {
    emit('click')
  }
}
</script>

<style lang="scss" scoped>
.gi-GroupIcon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: v-bind('resolvedBorderRadius');
  background-color: var(--ob-gi-bg-color, var(--color));
  color: var(--ob-gi-color, #{$dark-2});
  transition: background-color $transition-fast, color $transition-fast;

  .csi-Item-active & {
    color: inherit;
  }

  &-clickable {
    cursor: pointer;
  }
}
</style>
